
/**
 * @fileOverview Secondary Navigation Controller
 * @modified 01/27/2015
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/SecondaryNavController',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

        $debug('secondary nav is loaded...', 'mmmSecondaryNav');

		var secondaryNavController = function($element){
			this.trigger = $element;
			this.triggerItem = $element.data('uniquename');
			this.target = $('#' + this.triggerItem);
			this.menuOpen = false;

			this.init();
		};

		secondaryNavController.prototype.init = function(){
			$debug('secondary nav init', 'mmmSecondaryNav');
			$debug(this.trigger, 'mmmSecondaryNav');
			
			this.setupHandlers();
		};

		secondaryNavController.prototype.setupHandlers = function(){
			var self = this;

			// Event Handlers for closing the navigation
			$('body').on('click', function(event){
				if(self.menuOpen && !self.psnMenuClick(event)){
					event.preventDefault();
					self.hideContent(event, self.trigger);
				} else{
					if(self.psnClick(event)){
						var $target = $(event.target).parents('.js-secondaryNavLink');
						if($(event.target).hasClass('js-secondaryNavLink')){
							$target = $(event.target);
						}

						if(self.target.length > 0){
							if($target.hasClass('MMM--isActive')){
								event.preventDefault();
								self.hideContent(event, $target);
							} else{
								event.preventDefault();
								self.showContent(event, $target);
							}
						}
					}
				}
			});

			return this;
		};

		secondaryNavController.prototype.showContent = function(event, $element){
			var self = this,
				minWidth = $(window).innerWidth();	//jcj: fixed typo from 'innerWdith()'

			$('.js-secondaryNavLink').each(function(){
				if($(this).data('uniquename').indexOf('#') < 0){
					self.hideContent(event, $(this));
				}
			});

			$element.addClass('MMM--isActive');

			// If the window is wider than the element's outer width, set the minimum width to that, otherwise use the width of the window
			//9/2/2015 JCJ: Bad syntax in the following line:
			//minWidth = minWidth > $element.outerWidth() ? $element.outerWidth()
			
			if(minWidth > $element.outerWidth()){
				minWidth = $element.outerWidth();
			}
			

			self.target.addClass('MMM--isActive').css({'top': $element.position().top + $element.outerHeight()-2, 'left': $element.position().left, 'min-width': minWidth});
			self.menuOpen = true;

			return this;
		};

		secondaryNavController.prototype.hideContent = function(event, $element){
			var thisTarget = $element.data('uniquename');

			$element.removeClass('MMM--isActive');
			$('#' + thisTarget).removeClass('MMM--isActive');
			this.menuOpen = false;

			return this;
		};

		secondaryNavController.prototype.psnClick = function(event){
			return ($(event.target).is(this.trigger) || $(event.target).parents('.js-secondaryNavLink').is(this.trigger));
		};

		secondaryNavController.prototype.psnMenuClick = function(event){
			return ($(event.target).hasClass('.MMM--secondarySubNavList') || $(event.target).parents('.MMM--secondarySubNavList').length > 0);
		};

		return secondaryNavController;
	});
}(MMMRequire));